export { SectionWithImageV2 } from './section-with-image-v2'
export type { SectionWithImageV2Props } from './section-with-image-v2'
